import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./Contact.css"; // Ensure correct path

const Contact = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    pincode: "",
    city: "",
    state: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.contact) newErrors.contact = "Contact number is required";
    if (!formData.pincode) newErrors.pincode = "Pin code is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.message) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form submitted:", formData);
      handleClose();
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered dialogClassName="custom-modal">
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title className="modal-title-custom">Contact Us</Modal.Title>
      </Modal.Header>
        <p>Please fill in the details and we will get back to you</p>
      <Modal.Body>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-12 col-12 mb-3">
              <label htmlFor="name" className="form-label">Name</label>
              <input type="text" className={`input_box ${errors.name ? "is-invalid" : ""}`} id="name" placeholder="Name" value={formData.name} onChange={handleChange} />
              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </div>
          </div>
          <div className="row">
          <div className="col-md-12 col-12 mb-3">
              <label htmlFor="contact" className="form-label">Contact Number</label>
              <input type="text" className={`input_box ${errors.contact ? "is-invalid" : ""}`} id="contact" placeholder="Contact Number" value={formData.contact} onChange={handleChange} />
              {errors.contact && <div className="invalid-feedback">{errors.contact}</div>}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 col-12 mb-3">
              <label htmlFor="pincode" className="form-label">Pin Code</label>
              <input type="text" className={`input_box ${errors.pincode ? "is-invalid" : ""}`} id="pincode" placeholder="Pincode" value={formData.pincode} onChange={handleChange} />
              {errors.pincode && <div className="invalid-feedback">{errors.pincode}</div>}
            </div>
            <div className="col-md-6 col-12 mb-3">
              <label htmlFor="city" className="form-label">City</label>
              <input type="text" className={`input_box ${errors.city ? "is-invalid" : ""}`} id="city" placeholder="City" value={formData.city} onChange={handleChange} />
              {errors.city && <div className="invalid-feedback">{errors.city}</div>}
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-12 mb-3">
              <label htmlFor="state" className="form-label">State</label>
              <input type="text" className={`input_box ${errors.state ? "is-invalid" : ""}`} id="state" placeholder="State" value={formData.state} onChange={handleChange} />
              {errors.state && <div className="invalid-feedback">{errors.state}</div>}
            </div>
          </div>

          <div className="r">
          <div className="col-md-12 col-12 mb-3">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea className={`input_box ${errors.message ? "is-invalid" : ""}`} id="message" rows="3" placeholder="Message" value={formData.message} onChange={handleChange} />
              {errors.message && <div className="invalid-feedback">{errors.message}</div>}
            </div>
          </div>
        </form>
        <p>By clicking submit, your consent to share your personal information in this from which will be processed in accordance with Frashnear Technology Private Limited's policies, Including Valm's privacy policy.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} className="styled-button">Close</Button>
        <Button variant="primary" onClick={handleSubmit} className="styled-button">Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Contact;
